import React, { useState } from "react";
import {
  Container,
  Grid,
  Paper,
  Typography,
  TextField,
  Button,
  IconButton,
} from "@mui/material";
import { LinkedIn, GitHub } from "@mui/icons-material";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import AnimatedCircles from "../components/Animation";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(
        "https://portfolio-server-1fm2.onrender.com/send-message",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      if (response.ok) {
        console.log("Email sent successfully");
        setFormData({
          name: "",
          email: "",
          message: "",
        });
        setSuccess("Email sent successfully");
      } else {
        console.error("Email sending failed");
      }
    } catch (error) {
      console.error("Error:", error);
      setError("Email sending failed");
    }
  };

  const downloadPdf = () => {
    const pdfUrl =
      "https://portfolio-server-1fm2.onrender.com/Maia-Kiknavelidze-Resume.pdf";

    const a = document.createElement("a");
    a.href = pdfUrl;
    a.target = "_blank";
    a.download = "Maia-Kiknavelidze-Resume.pdf";

    a.click();

    a.remove();
  };

  return (
    <>
      <AnimatedCircles />
      <Container
        sx={{
          marginTop: "2rem",
          display: "flex",
          alignItems: "center",
        }}
        maxWidth="lg"
        className="contact-page"
      >
        <Grid container spacing={3}>
          {/* Left Sidebar */}
          <Grid item xs={12} sm={4}>
            <Paper
              sx={{
                padding: "20px",
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                background: "transparent",
                color: "white",
                boxShadow: "0 0 10px black",
              }}
              elevation={3}
              className="contact-sidebar"
            >
              <Typography
                sx={{ borderBottom: "2px solid white", padding: "10px" }}
                variant="h4"
              >
                Get In Touch
              </Typography>
              <IconButton
                aria-label="LinkedIn"
                sx={{ color: "purple" }}
                href="https://www.linkedin.com/in/maia-kiknavelidze-459864253/"
              >
                <LinkedIn fontSize="large" />
              </IconButton>
              <IconButton
                aria-label="GitHub"
                sx={{ color: "purple" }}
                href="https://github.com/slunecnicee"
              >
                <GitHub fontSize="large" />
              </IconButton>
              <div>
                <Typography
                  variant="body1"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    padding: "8px",
                    marginBottom: "10px",
                    gap: "10px",
                    transition: "transform 0.2s, box-shadow 0.2s",
                    "&:hover": {
                      transform: "scale(1.1)",
                      boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.5)",
                    },
                  }}
                >
                  <PhoneIcon sx={{ color: "purple" }} /> (+995) 595 955 910
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    alignItems: "center",
                    gap: "10px",
                    padding: "8px",
                    marginBottom: "10px",
                    color: "white",
                    transition: "transform 0.2s, box-shadow 0.2s",
                    "&:hover": {
                      transform: "scale(1.1)",
                      boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.5)",
                    },
                  }}
                >
                  <EmailIcon sx={{ color: "purple" }} /> kikavelidzem2@gmail.com
                </Typography>
              </div>

              <Button
                variant="contained"
                color="primary"
                href="/your-resume.pdf"
                target="_blank"
                sx={{
                  backgroundImage: "linear-gradient(to right, blue, purple)",
                  marginBottom: "5px",
                }}
                onClick={downloadPdf}
              >
                View Resume
              </Button>
              <Button
                variant="contained"
                color="primary"
                href="/coverletter"
                sx={{
                  backgroundImage: "linear-gradient(to right, blue, purple)",
                  marginBottom: "5px",
                }}
              >
                Why Work With Me
              </Button>
            </Paper>
          </Grid>

          {/* Right Side: Contact Form */}
          <Grid item xs={12} sm={8}>
            <Paper
              sx={{
                padding: "10px",
                background: "transparent",
                color: "white",
                boxShadow: "0 0 10px black",
              }}
              elevation={3}
              className="contact-form"
            >
              <Typography
                sx={{ borderBottom: "1px solid white", padding: "3px" }}
                variant="h4"
              >
                Contact Me
              </Typography>
              <form>
                <TextField
                  label="Name"
                  value={formData.name}
                  name="name"
                  onChange={handleChange}
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  InputProps={{
                    sx: {
                      color: "white",
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderImage: "linear-gradient(to right, blue, purple)",
                        borderImageSlice: "1",
                        borderWidth: 3,
                      },
                      "&:focus .MuiOutlinedInput-notchedOutline": {
                        borderImage: "linear-gradient(to right, blue, purple)",
                        borderImageSlice: "1",
                        borderWidth: 3,
                      },
                    },
                  }}
                  InputLabelProps={{
                    sx: {
                      color: "white",
                    },
                  }}
                />
                <TextField
                  label="Email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  InputProps={{
                    sx: {
                      color: "white",
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderImage: "linear-gradient(to right, blue, purple)",
                        borderImageSlice: "1",
                        borderWidth: 3,
                      },
                      "&:focus .MuiOutlinedInput-notchedOutline": {
                        borderImage: "linear-gradient(to right, blue, purple)",
                        borderImageSlice: "1",
                        borderWidth: 3,
                      },
                    },
                  }}
                  InputLabelProps={{
                    sx: {
                      color: "white",
                    },
                  }}
                />
                <TextField
                  label="Message"
                  variant="outlined"
                  fullWidth
                  value={formData.message}
                  onChange={handleChange}
                  name="message"
                  multiline
                  rows={4}
                  margin="normal"
                  InputProps={{
                    sx: {
                      color: "white",
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderImage: "linear-gradient(to right, blue, purple)",
                        borderImageSlice: "1",
                        borderWidth: 3,
                      },
                      "&:focus .MuiOutlinedInput-notchedOutline": {
                        borderImage: "linear-gradient(to right, blue, purple)",
                        borderImageSlice: "1",
                        borderWidth: 3,
                      },
                    },
                  }}
                  InputLabelProps={{
                    sx: {
                      color: "white",
                    },
                  }}
                />
                <Button
                  sx={{
                    backgroundImage: "linear-gradient(to right, blue, purple)",
                  }}
                  variant="contained"
                  color="primary"
                  type="submit"
                  onClick={handleSubmit}
                >
                  Send
                </Button>
              </form>
            </Paper>
          </Grid>
        </Grid>
        {error && (
          <Typography variant="body1" sx={{ color: "red", fontWeight: "bold" }}>
            {error}
          </Typography>
        )}
        {success && (
          <Typography
            variant="body1"
            sx={{ color: "green", fontWeight: "bold" }}
          >
            {success}
          </Typography>
        )}
      </Container>
    </>
  );
};

export default Contact;
